export default __webpack_public_path__ + "static/media/folyamatabra2.e39c08fa.jpg";